import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'daily-reports';

export function index({
  page, size, order_by, is_asc, store_id, start_date, end_date,
}) {
  return get({
    url,
    data: {
      store_id,
      start_date,
      end_date,
      order_by,
      is_asc,
      page,
      size,
    },
  });
}

export function getIncomes({ store_id, report_date }) {
  return get({
    url: `${url}/incomes`,
    data: {
      store_id,
      report_date: report_date,
    },
  });
}

export function getRefunds({ store_id, report_date }) {
  return get({
    url: `${url}/refunds`,
    data: {
      store_id,
      report_date: report_date,
    },
  });
}

export function getUpdatePayments(data) {
  return get({
    url: `${url}/update-payments`,
    data,
  });
}

export function getReservationIncomes(data) {
  return get({
    url: `${url}/reservation-incomes`,
    data,
  });
}

export function getReservationPays(data) {
  return get({
    url: `${url}/reservation-pays`,
    data,
  });
}

export function getCardTicketIncomes(data) {
  return get({
    url: `${url}/card-ticket-incomes`,
    data,
  });
}

export function getVoucherIncomes(data) {
  return get({
    url: `${url}/voucher-incomes`,
    data,
  });
}

export function getCardTicketRefunds(data) {
  return get({
    url: `${url}/card-ticket-refunds`,
    data,
  });
}

export function getVoucherRefunds(data) {
  return get({
    url: `${url}/voucher-refunds`,
    data,
  });
}

export function getMonthlyIncomes(store_id) {
  return get({
    url: `${url}/monthly-incomes`,
    data: {
      store_id,
    },
  });
}

export function getCourses({ store_id, report_date }) {
  return get({
    url: `${url}/courses`,
    data: {
      store_id,
      report_date: report_date,
    },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
